import React, { FC, ReactElement, useEffect } from 'react';
import { Route, Switch, withRouter, useHistory, useLocation } from 'react-router-dom'
import { Home } from 'pages'
import { Routers, hideMenu } from 'routers'
import { Header, Footer } from 'components'
import api from 'api/xqjy-service'
import store from 'store/index'
import { setMember } from 'store/actions'
import { getToken } from 'api/request';
import 'dayjs/locale/zh-cn';

// 不用登陆可访问页面
const ignoredPaths = [
  "/login", "/envImage"
]

const App: FC = (): ReactElement => {

  const location = useLocation()
  const history = useHistory()
  const hideHeader = hideMenu(history.location.pathname)
  window.reactHistory = history

  
  useEffect(()=>{
    const token = getToken()
    console.log('init token:', token)
    if(token){
      api.member.currentInfo({}).then(result=>{
        store.dispatch(setMember(result.data))
      })
    }
  },[])

  // 监控路由变化
  useEffect(() => {
    const pathname = location.pathname
    if(ignoredPaths.indexOf(pathname) < 0){
      if(!getToken()){
        history.push('/login')
      }
    }
  }, [history, location.pathname]);

  return (
    <div className="app">
      {!hideHeader && <Header></Header>}
      <div className="main">
        <Switch>
          {
            Routers.map(router => (
              <Route
                exact={!router.notExect}
                key={router.path}
                path={router.path}
                component={router.component}
              >
              </Route>
            ))
          }
          <Route path="/" component={Home} exact></Route>
        </Switch>
      </div>
      {!hideHeader && <Footer></Footer>}
    </div>
  )
}

export default withRouter(App)
